'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorBody = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseTimeoutTransitionGroup = require('@bibliocommons/base-timeout-transition-group');

var _baseTimeoutTransitionGroup2 = _interopRequireDefault(_baseTimeoutTransitionGroup);

var _utilsList = require('@bibliocommons/utils-list');

var _constantsList = require('@bibliocommons/constants-list');

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

require('@bibliocommons/assets/stylesheets/animations.scss');

var _addToList = require('../../add-to-list');

var _addToList2 = _interopRequireDefault(_addToList);

var _itemsList = require('../../items-list');

var _itemsList2 = _interopRequireDefault(_itemsList);

var _itemLimitReachedAlert = require('../../item-limit-reached-alert');

var _itemLimitReachedAlert2 = _interopRequireDefault(_itemLimitReachedAlert);

require('../styles/EditorBody.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: this won't quite work


var ANIMATION_TIME = 500;

var EditorBody = exports.EditorBody = function (_BcReactComponent) {
  _inherits(EditorBody, _BcReactComponent);

  function EditorBody(props) {
    _classCallCheck(this, EditorBody);

    var _this = _possibleConstructorReturn(this, (EditorBody.__proto__ || Object.getPrototypeOf(EditorBody)).call(this, props));

    _this.bindAll('renderListSizeInfo', 'renderAddToList', 'addToListOpenOnTop', 'handleOpenAddToList', 'resetAddToListOpenedFromBody');
    _this.state = {
      addToListOpenedFromBody: false
    };
    return _this;
  }

  _createClass(EditorBody, [{
    key: 'handleOpenAddToList',
    value: function handleOpenAddToList() {
      this.setState({ addToListOpenedFromBody: true });
      this.props.handleOpenAddToList();
    }
  }, {
    key: 'focusOnAddToList',
    value: function focusOnAddToList() {
      if (this.props.items.size >= _constantsList.MAX_LIST_ITEMS && this._itemLimitReachedAlert) {
        this._itemLimitReachedAlert.focus();
      } else if (this._addToListWrapper) {
        this.props.restoreFocus();
        this.props.captureFocus(this._addToListWrapper, false);
      }
    }
  }, {
    key: 'resetAddToListOpenedFromBody',
    value: function resetAddToListOpenedFromBody() {
      this.setState({ addToListOpenedFromBody: false });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Return focus to "Add to List" button if add to list was just closed
      if (this.props.keepSearchResultsOpen && prevProps.addToListOpen && !this.props.addToListOpen) {
        if (this._addToListButton && this.state.addToListOpenedFromBody) {
          this.props.restoreFocus(this._addToListButton);
        } else {
          this.props.restoreFocus();
        }
        this.resetAddToListOpenedFromBody();
      }

      if (!prevProps.addToListOpen && this.props.addToListOpen) {
        if (this._addToListComponent) {
          this.props.captureFocus(this._addToListComponent, false);
        }
      }
    }
  }, {
    key: 'renderListSizeInfo',
    value: function renderListSizeInfo() {
      if (this.props.items && this.props.items.size >= 4) {
        return false;
      }
      return _react2.default.createElement(
        _baseAlerts.AlertInfo,
        null,
        _react2.default.createElement(
          'span',
          { 'data-test-id': 'list-minimum-length-error' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_error_minimum_length' })
        )
      );
    }
  }, {
    key: 'renderAddToList',
    value: function renderAddToList() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'add-to-list-form', ref: function ref(el) {
            return _this2._addToListWrapper = el;
          } },
        this.renderAddToListContents()
      );
    }
  }, {
    key: 'renderAddToListContents',
    value: function renderAddToListContents() {
      var _this3 = this;

      if (this.props.editingAnchorBib || !this.props.showAddToList) {
        return null;
      }

      if (this.props.items.size >= _constantsList.MAX_LIST_ITEMS) {
        return _react2.default.createElement(_itemLimitReachedAlert2.default, { ref: function ref(el) {
            return _this3._itemLimitReachedAlert = el;
          } });
      }

      if (this.props.addToListOpen) {
        return _react2.default.createElement(_addToList2.default, {
          ref: function ref(el) {
            return _this3._addToListComponent = el;
          },
          listItems: this.props.items,
          searchResults: this.props.searchResults,
          searchParams: this.props.searchParams,
          webItem: this.props.webItem,
          allowFreeText: this.props.allowFreeText,
          keepSearchResultsOpen: this.props.keepSearchResultsOpen,
          handleSearchParameterChange: this.props.handleSearchParameterChange,
          handleSearch: this.props.handleSearch,
          handleAddBib: this.props.handleAddBib,
          handleAddWebItem: this.props.handleAddWebItem,
          getNextPageSearchResults: this.props.getNextPageSearchResults,
          handleClearSearch: this.props.handleClearSearch,
          handleWebItemPropertyChange: this.props.handleWebItemPropertyChange,
          handleCloseAddToList: this.props.handleCloseAddToList,
          handleWebURLSelected: this.props.handleWebURLSelected,
          availabilityDetailActions: this.props.availabilityDetailActions });
      }

      return _react2.default.createElement(
        'div',
        { className: 'add-to-list-form' },
        _react2.default.createElement(
          _baseButtons.PrimaryButton,
          {
            ref: function ref(el) {
              return _this3._addToListButton = el;
            },
            className: 'btn btn-add-to-list',
            block: true,
            'data-test-id': 'add-to-list-button',
            handleClick: this.handleOpenAddToList },
          _react2.default.createElement('i', { 'aria-hidden': true, className: 'icon-plus' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_add_to_list' })
        )
      );
    }
  }, {
    key: 'addToListOpenOnTop',
    value: function addToListOpenOnTop() {
      return this.props.addItemsToTop && this.props.items.size > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _utilsList.isReadalikeList)(this.props.list) && !this.props.list.get('anchorBib')) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-editor-body' },
        _react2.default.createElement(
          'div',
          { className: 'alerts' },
          this.renderListSizeInfo()
        ),
        _react2.default.createElement(
          _baseTimeoutTransitionGroup2.default,
          {
            transitionName: 'fade',
            transitionEnter: false,
            leaveTimeout: ANIMATION_TIME,
            handleTransitionComplete: this.props.handleAddItemsMoved },
          this.addToListOpenOnTop() ? this.renderAddToList() : null
        ),
        _react2.default.createElement(_itemsList2.default, {
          items: this.props.items,
          showItemIndexes: this.props.list.get('isRanked'),
          allowFreeText: this.props.allowFreeText,
          keepSearchResultsOpen: this.props.keepSearchResultsOpen,
          addItemsToTop: this.props.addItemsToTop,
          handleItemPropertyChange: this.props.handleItemPropertyChange,
          handleItemDragged: this.props.handleItemDragged,
          handleRemoveItem: this.props.handleRemoveItem,
          handleItemMovedUp: this.props.handleItemMovedUp,
          handleItemMovedDown: this.props.handleItemMovedDown }),
        _react2.default.createElement(
          _baseTimeoutTransitionGroup2.default,
          {
            transitionName: 'fade',
            transitionEnter: false,
            leaveTimeout: ANIMATION_TIME,
            handleTransitionComplete: this.props.handleAddItemsMoved },
          !this.addToListOpenOnTop() ? this.renderAddToList() : null
        )
      );
    }
  }]);

  return EditorBody;
}(_baseBcReactComponent2.default);

EditorBody.propTypes = {
  list: _bcPropTypes.listShape,
  handleSearch: _react.PropTypes.func.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map,
  webItem: _reactImmutableProptypes2.default.map,
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  addToListOpen: _react.PropTypes.bool,
  showAddToList: _react.PropTypes.bool,
  allowFreeText: _react.PropTypes.bool.isRequired,
  keepSearchResultsOpen: _react.PropTypes.bool.isRequired,
  addItemsToTop: _react.PropTypes.bool,

  handleAddBib: _react.PropTypes.func.isRequired,
  handleRemoveItem: _react.PropTypes.func.isRequired,
  handleItemPropertyChange: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,
  handleClearSearch: _react.PropTypes.func.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  handleItemDragged: _react.PropTypes.func.isRequired,
  handleOpenAddToList: _react.PropTypes.func.isRequired,
  handleCloseAddToList: _react.PropTypes.func.isRequired,
  handleAddItemsMoved: _react.PropTypes.func.isRequired,
  handleItemMovedUp: _react.PropTypes.func.isRequired,
  handleItemMovedDown: _react.PropTypes.func.isRequired,
  handleWebURLSelected: _react.PropTypes.func.isRequired,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,

  // injected by manageFocus
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired,

  intl: _reactIntl.intlShape
};

exports.default = (0, _baseAccessibilityManageFocus2.default)((0, _reactIntl.injectIntl)(EditorBody, { withRef: true }));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-body/components/EditorBody.component.js
// module id = 1291
// module chunks = 0